<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <span>Meu <span v-if="cartInfo.tipo == 'kombi'">Carrinho</span><span v-else-if="cartInfo.tipo == 'cotacao'">Cotação</span></span>
                    </li>
                </ul>
            </div>
            <div class="main-content-area">
                <div class="main-content-area">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Meu <span v-if="cartInfo.tipo == 'kombi'">Carrinho</span><span v-else-if="cartInfo.tipo == 'cotacao'">Cotação</span>: {{cartInfo.kombiCode}}</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="box-title">Faturamento para venda direta</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <vue-good-table :columns="columnsCli"
                                            :rows="cartInfo.clienteInfo"
                                            :pagination-options="{enabled: false}"
                                            styleClass="vgt-table">
                                <template slot="table-row" slot-scope="props">
                                    {{props.formattedRow[props.column.field]}}
                                </template>
                                <div slot="emptystate">Sem dados para exibição</div>
                            </vue-good-table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="box-title">Transportadora</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>
                                Local de Entrega: <strong>{{cartInfo.address}}</strong>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <strong>Frete CIF</strong> "por conta do emitente"
                        </div>
                    </div>
                    <!-- COVID-19 -->

                    <div v-if="cifTransportadora.length < 1 || (this.formulario.Cidade_cliente === 'MARINGA' && this.blockRetira === false)">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    <p><strong>CIF indisponível para sua região.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <br>
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <FormHelper
                                    :inputVar="cartInfo.cif"
                                    :form="cartInfo"
                                    :options="cifTransportadora"
                                    type="radio"
                                    label="Transportadora para frete CIF"
                                ></FormHelper> -->
                                <label v-for="(option, index) in cifTransportadora" :key="index" class="inline-radio col-md-12">
                                    <input class="col-md-1"
                                           v-model="cartInfo.cif.value"
                                           type="radio"
                                           :value="option.RazaoSocial"
                                           :name="option.value"
                                           :disabled="!!false"
                                           style="width: 22px;" />
                                    <span class="col-md-5">{{option.RazaoSocial}}</span>
                                    <span class="col-md-3">{{option.Prazo}}</span>
                                    <span class="col-md-3">{{option.Frete}}</span>
                                </label>

                            </div>
                        </div>
                        <div v-if="strMsgDiferencaLogistica != ''">
                            <div class="row">
                                <div class="alert-group">
                                    <div class="alert alert-warning alert-dismissable">
                                        <strong>Aviso!</strong> <br />
                                        {{strMsgDiferencaLogistica}}
                                        <br />
                                        <div style="font-size:13px">
                                            <span>O valor pode sofrer variações se o local de entrega for área rural</span><span v-if="cartInfo.totalAmountClienteCreditCard > 0"> ou se a forma de pagamento for cartão de crédito</span><span>.</span>
                                        </div>
                                        <div v-if="cartInfo.totalAmountClienteCreditCard > 0" style="font-weight: 600; padding-top: 2px;">
                                            <row>
                                                Parcelas: <strong>{{cartInfo.installmentNumber}}x de {{this.formatCurrency(parseFloat(this.cartInfo.totalAmountCliente.replace('R$', '').replace('.', '').replace(',','.')) / this.cartInfo.installmentNumber)}}</strong>.
                                            </row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning" role="alert">
                                <p><strong>Informe o nome e telefone para agendar à entrega. Não utilize o campo observação para este fim.</strong></p>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="font-weight:bold" id="rowAgendamentoEntrega">
                        <div class="col-md-2">
                            <label style="font-weight:bold;padding-top:30px;font-size:18px">Agendar Entrega</label>
                        </div>
                        <div class="col-md-5">
                            <FormHelper :inputVar="cartInfo.entrega_nome"
                                        :form="cartInfo"
                                        maxlength="40"
                                        label="Nome"
                                        type="text"
                                        id="txtEntregaNome"
                                        class="agendamento_entrega"
                                        name="txtEntregaNome"
                                        placeholder="Nome"></FormHelper>
                        </div>
                        <div class="col-md-5">
                            <FormHelper :inputVar="cartInfo.entrega_telefone"
                                        :form="cartInfo"
                                        maxlength="40"
                                        label="Telefone"
                                        type="text"
                                        class="agendamento_entrega"
                                        id="txtEntregaTelefone"
                                        name="txtEntregaTelefone"
                                        placeholder="Telefone"></FormHelper>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <strong>Frete FOB</strong> "por conta do destinatário"
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-danger" role="alert">
                                <p>
                                    <strong>Atenção Contratação, pagamento e risco do transporte é de responsabilidade do destinatário.</strong><br>
                                    Caso não encontre sua transportadora de preferência, na lista abaixo, entre em contato com a área comercial para providenciarmos o cadastro dela.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <strong>Para Frete FOB, verifique com a transportadora escolhida se há disponibilidade de atendimento em sua região</strong>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-12">
                            <FormHelper :inputVar="cartInfo.fob"
                                        :form="cartInfo"
                                        :options="fobCompanies"
                                        type="select"
                                        label="Transportadora para frete FOB"
                                        placeholder="Transportadora"></FormHelper>
                        </div>
                    </div>
                    <div id="responsible">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    <p><strong>Informe o responsável pela retira, abaixo.</strong></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10">
                                <FormHelper :inputVar="cartInfo.responsible"
                                            :form="cartInfo"
                                            :options="responsibles"
                                            type="select"
                                            label="Responsável para retira"
                                            placeholder="Responsável"></FormHelper>
                            </div>
                            <div class="col-md-2 col-only-button" style="z-index: -1;">
                                <input id="resp-code" class="form-control" value="" disabled="true" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <FormHelper :inputVar="cartInfo.obs"
                                        :form="cartInfo"
                                        maxlength="200"
                                        label="Observação"
                                        type="textarea"
                                        id="txtArea"
                                        name="txtArea"
                                        placeholder="Observação"></FormHelper>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="box-title">Informações para revenda</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <vue-good-table :columns="columnsTaxes"
                                            :rows="cartInfo.taxesInfo"
                                            :pagination-options="{enabled: false}"
                                            styleClass="vgt-table">
                                <template slot="table-row" slot-scope="props">
                                    {{formatCurrency(props.formattedRow[props.column.field])}}
                                </template>
                                <div slot="emptystate">Sem dados para exibição</div>
                            </vue-good-table>
                        </div>
                    </div>
                    <div class="row" v-if="!isConsumoProprio">
                        <div class="col-md-6">
                            <span class="cart-table-foot pull-left">{{cartInfo.totalItems}} item(s)</span>
                        </div>
                        <div class="col-md-6">
                            <span class="cart-table-foot pull-right">Total do Carrinho: {{cartInfo.totalAmount}}</span>
                        </div>
                    </div>
                    <div v-if="!isConsumoProprio">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="box-title vermelho">Informações para cliente final</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button
                                    aria-label="Meu Prêmio"
                                    class="btn btn-success pull-right"
                                    style="margin-bottom: 15px"
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#prize-modal"
                                    @click="$refs.prizeModal.getPremio()"
                                >
                                    <i class="fa fa-bar-chart fa-lg" /> MEU PRÊMIO
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <vue-good-table :columns="columnsTaxesCliente"
                                                :rows="cartInfo.taxesInfoCliente"
                                                :pagination-options="{enabled: false}"
                                                styleClass="vgt-table">
                                    <template slot="table-row" slot-scope="props">
                                        {{formatCurrency(props.formattedRow[props.column.field])}}
                                    </template>
                                    <div slot="emptystate">Sem dados para exibição</div>
                                </vue-good-table>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <span class="cart-table-foot pull-left">{{cartInfo.totalItems}} item(s)</span>
                        </div>
                        <div class="col-md-6">
                            <span class="cart-table-foot pull-right">Total do Carrinho: {{cartInfo.totalAmountCliente}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="cartInfo.tipo == 'kombi'" class="col-md-6">
                            <button aria-label="Excluir" class="btn btn-danger" v-on:click.prevent="deleteAction()">Excluir Carrinho</button>
                        </div>
                        <div v-if="cartInfo.tipo == 'cotacao'" class="col-md-2">
                            <button aria-label="Excluir" class="btn btn-danger" v-on:click.prevent="deleteAction()">Excluir Carrinho</button>
                        </div>
                        <div v-if="cartInfo.tipo == 'cotacao'" class="col-md-4">
                            <!-- <button class="btn btn-primary" v-on:click.prevent="expressAction()">Enviar Cotação Express</button> -->
                        </div>
                        <div v-if="cartInfo.tipo == 'kombi'" class="col-md-5">
                            <button aria-label="Voltar" class="btn btn-primary pull-right" v-on:click.prevent="returnAction()" v-bind:disabled='isProcessing'>Voltar</button>
                        </div>
                        <div v-else-if="cartInfo.tipo == 'cotacao'" class="col-md-4">
                            <button aria-label="Voltar" class="btn btn-warning pull-right" v-on:click.prevent="returnAction()">Voltar</button>
                        </div>
                        <div v-if="cartInfo.tipo == 'kombi'" class="col-md-1">
                            <button aria-label="Finalizar" class="btn btn-primary" v-on:click.prevent="finishAction()" v-bind:disabled='isProcessing'>Finalizar</button>
                            <div v-if="isProcessing">
                                <Loader style="margin-top: 8px; margin-left: 15px; position: absolute;" />
                            </div>
                        </div>
                        <div v-else-if="cartInfo.tipo == 'cotacao'" class="col-md-2">
                            <button aria-label="Converter em Carrinho" class="btn btn-warning" v-on:click.prevent="convertAction()">Converter em Carrinho</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PrizeModal :codigoPedido="codigoKombiInt" ref="prizeModal" />
    </main>
</template>
<script>
    import "vue-good-table/dist/vue-good-table.css";
    import FormHelper from "./partials/FormHelper.vue";
    import PrizeModal from "./partials/PrizeModal";
    import { VueGoodTable } from "vue-good-table";
    import swal from "sweetalert";

    export default {
        name: 'SelectShipping',
        components: {
            VueGoodTable,
            FormHelper,
            PrizeModal
        },
        mounted() {
            const self = this
            var $resp = jQuery("#responsible");
            $("#txtArea").blur(function () {
                var value = jQuery(this).val();
                if (value != '') {
                    self.updateObsCliente(value, true);
                }
            });
            $("#rowAgendamentoEntrega input[type=text]").blur(function () {
                var valueTelefone = $("#txtEntregaTelefone").val().trim();
                var valueNome = $("#txtEntregaNome").val().trim();
                if (valueTelefone == '' || valueNome == '') {
                    return;
                }
                self.updateObsAgendamentoEntrega(valueNome.trim(), valueTelefone.trim());
            });


            if (localStorage.fobKombiDirect !== "O MESMO" && self.blockRetira == false) {
                $resp.hide();
            }

            this.getSession().success(session => {
                this.session = session;

                if (session.CodigoPedido != -1) {
                    this.codigoKombiInt = session.CodigoPedido;
                }
                else if (session.CodigoOrcamento != -1) {
                    this.codigoKombiInt = session.CodigoOrcamento;
                    this.isQuotation = true;
                }

                if (!this.isQuotation && this.$route.params.tipo === 'cotacao') {
                    location.href = `${self.$SiteUrl}/transportadora-venda-direta/carrinho`
                }

                this.cartInfo.totalAmount = session.carrinhoTotalNotaFiscalSemFrete;
                this.cartInfo.totalItems = session.quantidadeItensNoCarrinho;
                this.dadosFormulario();
            })
        },
        data() {
            return {
                codigoTransportadora: 0,
                rgResponsavel: '',
                strMsgDiferencaLogistica: '',
                showCifCompanies: true,
                reloadCompanies: true,
                codigoKombiInt: 0,
                blockRetira: false,
                isConsumoProprio: false,
                isProcessing: false,
                showModal: false,
                session: {},
                premio: {},
                formulario: {},
                fobCompanies: [],
                responsibles: [],
                cifTransportadora: [],
                cartInfo: {
                    attemptSubmit: false,
                    tipo: this.$route.params.tipo,
                    kombiCode: "",
                    totalAmount: 0,
                    totalAmountCliente: 0,
                    totalAmountClienteCreditCard: 0,
                    installmentNumber: 0,
                    totalItems: 0,
                    entrega_nome: new this.$formInput(false),
                    entrega_telefone: new this.$formInput(false),
                    obs: new this.$formInput(false),
                    cif: new this.$formInput(false, localStorage.cifKombiDirect),
                    fob: new this.$formInput(false, localStorage.fobKombiDirect),
                    responsible: new this.$formInput(false),
                    address: "",
                    clienteInfo: [],
                    taxesInfo: [],
                    taxesInfoCliente: [],
                },
                cifCompanies: [],
                columnsCli: [
                    { label: "Código", field: "codigo" },
                    { label: "CPF/CNPJ", field: "cpfCnpj" },
                    { label: "Razão Social", field: "razaoSoci" },
                    { label: "UF", field: "uf" }
                ],
                columnsTaxes: [
                    { label: "IPI", field: "ipi", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Out. Desp.", field: "outDesp", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Base Calc. Icms", field: "bcIcms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Icms", field: "icms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Base Calc. Icms Retido", field: "bcrIcms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Icms Subst. Trib.", field: "icmsSubT", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Total produtos", field: "totalPord", tdClass: "align-center-td", thClass: "align-center-td" }
                ],
                columnsTaxesCliente: [
                    { label: "IPI", field: "ipi", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Out. Desp.", field: "outDesp", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Base Calc. Icms", field: "bcIcms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Icms", field: "icms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Base Calc. Icms Retido", field: "bcrIcms", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Dif. de Alíquota", field: "icmsSubT", tdClass: "align-center-td", thClass: "align-center-td" },
                    { label: "Total produtos", field: "totalPord", tdClass: "align-center-td", thClass: "align-center-td" }
                ],
                productTaxesValue: [
                    {
                        code: "1234-5",
                        value: 2000.00,
                        valueCli: 2500.00,
                        ipi: 8.00,
                        ipiCli: 11.00,
                        pis: 8.00,
                        pisCli: 11.00,
                        cofins: 8.00,
                        cofinsCli: 11.00,
                        icms: 8.00,
                        icmsCli: 11.00,
                        difIcms: 0.00
                    },
                    {
                        code: "4321-5",
                        value: 3000.00,
                        valueCli: 3500.00,
                        ipi: 8.00,
                        ipiCli: 11.00,
                        pis: 8.00,
                        pisCli: 11.00,
                        cofins: 8.00,
                        cofinsCli: 11.00,
                        icms: 8.00,
                        icmsCli: 11.00,
                        difIcms: 0.00
                    }
                ],
            }
        },
        watch: {
            "cartInfo.responsible.value": function (v) {
                var $code = jQuery("#resp-code");

                if (v != null) {
                    $code.val(v.code);
                    this.updateResponsible(v)
                } else {
                    $code.val("");
                }
            },
            "cartInfo.fob.value": function (v) {
                var $resp = jQuery("#responsible");

                if (v != null && v.code == 29) {
                    localStorage.fobKombiDirect = v.label;

                    this.cartInfo.cif.value = null;
                    $resp.show();
                    this.updateCompanieFob(v.code);

                    localStorage.cifKombiDirect = null;
                } else if (v != null) {
                    localStorage.fobKombiDirect = v.label;

                    this.cartInfo.cif.value = null;
                    $resp.hide();
                    this.updateCompanieFob(v.code);

                    localStorage.cifKombiDirect = null;
                } else {
                    this.cartInfo.responsible.value = null;
                    $resp.hide();
                }
            },
            "cartInfo.cif.value": function (val) {
                if (val != null) {
                    this.cartInfo.fob.value = null;

                    localStorage.cifKombiDirect = val;

                    localStorage.fobKombiDirect = 'Transportadora';
                    this.updateCompanieCif(val);
                }
            }
        },
        methods: {
            updateObsCliente: function (v, m) {
                let xhr = new XMLHttpRequest();
                xhr.open('POST', this.$apiUrl + "Carrinho.svc/AlterarObsCliente")
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let retorno = JSON.parse(xhr.responseText)
                        if (retorno[0].includes('Aviso')) {
                            swal({
                                title: "Aviso",
                                text: retorno[1],
                                icon: 'warning'
                            })
                        }
                        else if (retorno[0].includes('OK') && m == true) {
                            swal({
                                title: 'Observação atualizada com sucesso!',
                                icon: 'success'
                            })
                        }
                    }
                }
                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                    observacao: v
                }))
            },
            updateObsAgendamentoEntrega: function (n, t) {
                let xhr = new XMLHttpRequest();
                xhr.open('POST', this.$apiUrl + "Carrinho.svc/AlterarObsClienteAgendamentoEntrega")
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let retorno = JSON.parse(xhr.responseText)
                        if (retorno[0].includes('Aviso')) {
                            swal({
                                title: "Aviso",
                                text: retorno[1],
                                icon: 'warning'
                            })
                        }
                        else if (retorno[0].includes('OK')) {
                            swal({
                                title: 'Observação atualizada com sucesso!',
                                icon: 'success'
                            })
                        }
                    }
                }
                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                    nome: n,
                    telefone: t
                }))
            },
            getPremio() {
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("Carregando Premio...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)

                            // console.log('comissao', json)

                            let comissao = json.split('|');

                            this.premio.valorPremio = comissao[0]
                            this.premio.premioHtml = comissao[1]
                            this.showModal = true
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Carrinho.svc/ComissaoDoPedidoVendaDireta");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt
                }));
            },
            getSession() {
                return $.ajax({
                    url: this.$apiUrl + "Session.svc/getsessions",
                    dataType: "json",
                    type: "GET",
                    xhrFields: { withCredentials: true }
                });
            },
            dadosFormulario: function () {
                const self = this
                //// console.log(session);
                var pedidoParametro = 0;
                if (this.session.CodigoPedido === -1 && this.session.CodigoOrcamento === -1) {
                    swal({
                        title: "Nenhuma kombi/cotação foram encontrados",
                        buttons: "Ok",
                        dangerMode: true,
                        icon: "error"
                    }).then(() => {
                        location.href = `${self.$SiteUrl}/loja`;
                    })
                }
                else {
                    if (this.session.CodigoPedido != -1) {
                        pedidoParametro = this.session.CodigoPedido;
                    }
                    else if (this.session.CodigoOrcamento != -1) {
                        pedidoParametro = this.session.CodigoOrcamento;
                    }
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200) {
                            // console.log("Carregando Dados...");
                            if (xhr.responseText != "" && xhr.responseText != null) {
                                let json = JSON.parse(xhr.responseText);
                                this.formulario = json;
                                // console.log("Result (dados de formulario): ",json);
                                let cliente = {};
                                let impostos = {};
                                let impostosVD = {};
                                cliente.razaoSoci = json.Razao_social_cliente;
                                cliente.codigo = json.Codigo_cliente + "-" + json.Dv_cliente;
                                cliente.cpfCnpj = json.Cnpj_cliente;
                                cliente.uf = json.Uf_cliente;

                                impostos.ipi = json.Total_ip;
                                impostos.outDesp = json.Despesas_acessorias;
                                impostos.bcIcms = json.Total_base_icms;
                                impostos.icms = json.Total_icms;
                                impostos.bcrIcms = json.Total_base_icms_retido;
                                impostos.icmsSubT = json.Total_icms_retido;
                                impostos.totalPord = json.Total_produtos;

                                impostosVD.ipi = json.Total_ip_venda_direta;
                                impostosVD.outDesp = json.Despesas_acessorias_venda_direta;
                                impostosVD.bcIcms = json.Total_base_icms_venda_direta;
                                impostosVD.icms = json.Total_icms_venda_direta;
                                impostosVD.bcrIcms = json.Total_base_icms_retido_venda_direta;
                                impostosVD.icmsSubT = json.Total_icms_retido_venda_direta;
                                impostosVD.totalPord = json.Total_produtos_venda_direta;

                                if (json.Codigo_transportadora == 0) {
                                    this.cartInfo.cif.value = null;
                                    this.cartInfo.fob.value = null;
                                }
                                else if (json.Codigo_transportadora == 29)
                                    this.rgResponsavel = json.Rg_responsavel_retira;
                                else
                                    this.codigoTransportadora = json.Codigo_transportadora;

                                self.blockRetira = json.PedidoGeradorOuPainel;
                                this.cartInfo.taxesInfo = []
                                this.cartInfo.taxesInfoCliente = []
                                this.cartInfo.clienteInfo = []
                                this.cartInfo.obs = json.Observacao_cliente;
                                this.cartInfo.taxesInfo.push(impostosVD);
                                this.cartInfo.taxesInfoCliente.push(impostos)
                                this.cartInfo.clienteInfo.push(cliente);
                                this.cartInfo.totalAmount = this.formatCurrency(json.Total_nota_fiscal_venda_direta);
                                this.cartInfo.totalAmountCliente = this.formatCurrency(json.Total_nota_fiscal);
                                this.cartInfo.totalAmountClienteCreditCard = json.Valor_com_juros_cartao;
                                this.cartInfo.installmentNumber = json.Parcela_cartao_credito;

                                this.cartInfo.kombiCode = json.Codigo_pedido + "-" + json.Dv_pedido;
                                this.cartInfo.address = json.Endereco_cliente + ", " + json.Cidade_cliente + " - " + json.Uf_cliente + ", CEP: " + json.Cep_cliente;

                                if (this.reloadCompanies) {
                                    this.getCifCompanies();
                                    this.getFobCompanies();
                                    this.getResponsible();
                                }

                                this.getPremio();
                                this.getTipoPedido();
                            }
                        }
                    }
                    xhr.open("POST", this.$apiUrl + "Carrinho.svc/CarregarFormulario");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({
                        codigoPedidoInformado: pedidoParametro,
                        orcamento: this.isQuotation
                    }));
                }

            },
            convertAction: function () {
                const self = this
                swal({
                    title: "Converter Cotação em Carrinho?",
                    buttons: ["Cancelar", "Converter"]
                }).then(confirmou => {
                    if (confirmou) {
                        var xhr = new XMLHttpRequest();
                        xhr.onload = () => {
                            if (xhr.status == 200) {
                                // console.log("convertendo para kombi...");
                                if (xhr.responseText != "" && xhr.responseText != null) {
                                    let json = JSON.parse(xhr.responseText);
                                    // console.log("Result (cotacao para kombi): ",json);
                                    if (json.includes('OK')) {
                                        this.reloadKombi();
                                        location.href = `${self.$SiteUrl}/transportadora-venda-direta/carrinho`;
                                    }
                                    else {
                                        swal({
                                            title: "Aviso",
                                            text: json,
                                            icon: "warning",
                                            button: "Ok"
                                        })
                                        return;
                                    }
                                }
                            } else {
                                // console.log("state:", xhr.readyState, " status:", xhr.status);
                            }
                        }
                        xhr.open("POST", this.$apiUrl + "Carrinho.svc/ConverterOrcamentoEmKombi");
                        xhr.setRequestHeader("Content-Type", "application/json");
                        xhr.withCredentials = true;
                        xhr.send(JSON.stringify({
                            codigoPedido: this.codigoKombiInt,
                        }));
                    }
                    else {
                        return;
                    }
                });

            },
            reloadKombi: function () {
                const self = this
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("Recarregando carrinho...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result(recarregar carrinho): ", json);

                            this.getSession().success(session => {
                                // console.log("reload session:",session)
                                this.session = session;
                                if (session.CodigoPedido != -1) {
                                    this.codigoKombiInt = session.CodigoPedido;
                                }
                                else if (session.CodigoOrcamento != -1) {
                                    this.codigoKombiInt = session.CodigoOrcamento;
                                }
                            }).error(() => {
                                swal({
                                    title: "É necessário estar logado",
                                    icon: "warning"
                                }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
                            })
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Carrinho.svc/ReloadCarrinho");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                }));
            },
            finishAction: function () {
                if (this.cartInfo.totalAmountClienteCreditCard > 0) {
                    var valorParcelaFormatado = this.formatCurrency(parseFloat(this.cartInfo.totalAmountCliente.replace('R$', '').replaceAll('.', '').replace(',', '.')) / this.cartInfo.installmentNumber);

                    var content = document.createElement('div');
                    content.innerHTML = "Valor final após transportadora escolhida: <strong>" + this.cartInfo.totalAmountCliente
                        + "</strong><br>Parcelas: <strong>" + this.cartInfo.installmentNumber + "x de " + valorParcelaFormatado + "</strong>.";

                    swal({
                        icon: 'info',
                        title: "Forma de pagamento escolhida: Cartão de Crédito.",
                        content: content,
                        buttons: {
                            cancel: "Cancelar", alterar: { text: "Alterar parcelamento" }, finalizar: { text: "Finalizar", className: "bg-primary" }
                        }
                    }).then((value) => {
                        switch (value) {
                            case "finalizar":
                                this.finalizar(true);
                                break;
                            case "alterar":
                                this.returnAction();
                            default:
                                break;
                        }
                    });

                } else {
                    swal({
                        title: "Finalizar Pedido",
                        text: "Deseja finalizar o pedido?",
                        buttons: ["Cancelar", "Finalizar"]
                    }).then(confirmou => {
                        this.finalizar(confirmou);
                    });
                }
            },
            finalizar: function (confirmou) {
                if (confirmou) {
                    this.isProcessing = true;
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200) {
                            // console.log("finalizando pedido...");
                            if (xhr.responseText != "" && xhr.responseText != null) {
                                let json = JSON.parse(xhr.responseText);
                                if (json.includes('OK')) {
                                    localStorage.vendedor = "INTERNET";
                                    localStorage.formaPagamento = "vista";
                                    localStorage.meioPagamento = 'Boleto'
                                    localStorage.numCartaoBNDS = ''
                                    localStorage.validadeBNDS = ''
                                    localStorage.bandeiraBNDS = ''
                                    localStorage.bancoBNDS = ''
                                    localStorage.parcelaBNDS = ''
                                    localStorage.parcelaSelecionada = 'Parcelas'
                                    localStorage.cifKombiDirect = ''
                                    localStorage.fobKombiDirect = ''

                                    // swal({
                                    //     title: "Pedido finalizado com sucesso!",
                                    //     icon: "success",
                                    //     button:"Ok"
                                    // }).then(() => {
                                    //     location.href = `${self.$SiteUrl}/loja`
                                    // })

                                    // Google tag Manager - gtm.js
                                    let buy = {
                                        event: 'purchase',
                                        pageType: 'transactionSuccess',
                                        transaction_id: this.codigoKombiInt,
                                        value: this.cartInfo.totalAmount,
                                        items: JSON.parse(localStorage.products),
                                    }

                                    this.$gtm.push(buy);
                                    localStorage.buyDataLayer = JSON.stringify(buy);
                                    localStorage.removeItem('products');

                                    if (this.cartInfo.totalAmountClienteCreditCard > 0) {
                                        var content = document.createElement('div');
                                        content.innerHTML = "Enviaremos para você um link de pagamento com as informações do pedido, após ele ser confirmado pelo seu vendedor.";

                                        swal({
                                            icon: 'success',
                                            title: "Pedido confirmado para Cartão de Crédito.",
                                            content: content,
                                            button: "Ok"
                                        }).then(() => {
                                            location.href = '/carrinho-fechado';
                                        });
                                    } else {
                                        location.href = '/carrinho-fechado';
                                    }
                                }
                                else {
                                    let span = document.createElement("span")
                                    span.innerHTML = json.replace(/´/g, '');
                                    this.isProcessing = false;
                                    swal({
                                        title: "Aviso",
                                        content: span,
                                        icon: "warning",
                                        button: "Ok"
                                    })
                                    return;
                                }
                            }
                        } else {
                            // console.log("state:", xhr.readyState, " status:", xhr.status);
                        }
                    }
                    xhr.open("POST", this.$apiUrl + "Carrinho.svc/ConfirmarPedido");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({
                        codigoPedido: this.codigoKombiInt,
                        nomeUsuarioComprador: this.session.DadosCliente.UserNome
                    }));
                }
                else {
                    this.isProcessing = false;
                    swal({
                        title: "Cancelada a finalização do pedido.",
                        button: "Ok"
                    })
                    return;
                }
            },
            returnAction: function () {
                const self = this
                location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/` + this.$route.params.tipo;
            },
            deleteAction: function () {
                const self = this
                swal({
                    title: "Exclusão do carrinho",
                    text: "Deseja excluir o carrinho " + this.formulario.Codigo_pedido + "-" + this.formulario.Dv_pedido,
                    buttons: ["Cancelar", "Excluir"],
                    dangerMode: true,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            // console.log("Deletando carrinho...", willDelete);
                            var xhr = new XMLHttpRequest();
                            xhr.onload = () => {
                                if (xhr.status == 200) {
                                    // console.log("Deletando carrinho...", willDelete);
                                    if (xhr.responseText != "" && xhr.responseText != null) {
                                        let json = JSON.parse(xhr.responseText);
                                        // console.log("Result(deletar carrinho): ", xhr.responseText);
                                        localStorage.vendedor = "INTERNET";
                                        localStorage.formaPagamento = "vista";
                                        localStorage.meioPagamento = 'Boleto'
                                        localStorage.numCartaoBNDS = ''
                                        localStorage.validadeBNDS = ''
                                        localStorage.bandeiraBNDS = ''
                                        localStorage.bancoBNDS = ''
                                        localStorage.parcelaBNDS = ''
                                        localStorage.parcelaSelecionada = 'Parcelas'
                                        location.href = `${self.$SiteUrl}/loja`;
                                    }
                                } else {
                                    // console.log("state:", xhr.readyState, " status:", xhr.status);
                                }
                            }
                            xhr.open("POST", this.$apiUrl + "Carrinho.svc/CancelarPedido");
                            xhr.setRequestHeader("Content-Type", "application/json");
                            xhr.withCredentials = true;
                            xhr.send(JSON.stringify({
                                codigoPedido: this.codigoKombiInt,
                            }));
                        } else {
                            return;
                        }
                    });
            },
            expressAction: function () {

            },
            getTipoPedido: function () {
                const self = this
                let xhr = new XMLHttpRequest()

                xhr.open('POST', this.$apiUrl + "Carrinho.svc/GetTipoPedido")
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        let response = JSON.parse(xhr.responseText)
                        if (response.includes('IMOBILIZADO')) {
                            self.isConsumoProprio = true;
                            return;
                        }
                    }
                }

                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt
                }))
            },
            formatCurrency: function (v) {
                //formata valores floats para moeda
                v = v ? v.toString().replace(',', '.') : 0
                var formato = {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL"
                };
                return parseFloat(v).toLocaleString("pt-BR", formato);
            },
            filterCompanieCif: function (val) {
                return val.RazaoSocial === this.cartInfo.cif.value;
            },
            updateCompanieCif: function (code) {
                this.isProcessing = true;
                var self = this;
                var item = this.cifTransportadora.filter(this.filterCompanieCif)[0]
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("alterando transportadora...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result (alterar transportadora): ",json);

                            this.reloadCompanies = false
                            this.dadosFormulario()
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                    this.isProcessing = false;
                }
                xhr.open("POST", this.$apiUrl + "Carrinho.svc/AlterarTransportadora");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;

                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                    codigoTransportadora: item.code,
                    tipoFrete: 0,
                    tipoCorreio: this.formulario.Tipo_correio,
                    valorFrete: item.valorFrete.toString().replace('.', ','),
                    tipoAereo: item.tipoAereo
                }));
                xhr.onreadystatechange = () => {
                    if (xhr.status == 200) {
                        self.dadosFormulario();
                    }
                };
            },
            getCifCompanies: function () {
                this.cifTransportadora = []
                var self = this;
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("Carregando Dados...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result (): ",json);
                            json.forEach((element) => {
                                let item = {};
                                item.code = element.DadosTransportadora.Codigo;
                                item.RazaoSocial = element.DadosTransportadora.RazaoSocial;
                                item.Prazo = element.DadosFrete.prazoCalculado;
                                item.Frete = element.DadosFrete.frete;
                                item.value = element.DadosTransportadora.Codigo;
                                item.valorFrete = element.DadosFrete.valorFreteCalculado;
                                item.tipoAereo = !!element.DadosTransportadora.Aereo && element.DadosTransportadora.Aereo != 'T'
                                this.cifTransportadora.push(item);
                            })
                            if (self.cifTransportadora.filter(c => c.Frete == 'Valor logistica: GRÁTIS').length > 0) {
                                self.strMsgDiferencaLogistica = '';
                            }
                            else if (self.cifTransportadora.length > 0 && self.cifTransportadora.filter(c => c.Frete == 'Valor logistica: GRÁTIS').length == 0) {
                                self.strMsgDiferencaLogistica = 'A taxa logística está sendo cobrada pois o valor total do frete excedeu a política de frete grátis.';
                            }
                            let cifGratis = this.cifTransportadora.filter(c => c.Frete == 'Valor logistica: GRÁTIS');
                            let cifSelecionada = this.cifTransportadora.filter(c => c.code == this.codigoTransportadora);
                            if (cifSelecionada.length > 0)
                                this.cartInfo.cif.value = cifSelecionada[0].RazaoSocial;

                            if (this.cartInfo.totalAmountClienteCreditCard > 0) {
                                this.updateCompanieCif(this.cartInfo.cif.value)
                                self.strMsgDiferencaLogistica = 'Valores de frete atualizados de acordo com total do pedido.';
                            }
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Transportadora.svc/loadcif");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    pedido: this.formulario,
                    valorNotaFiscalSemFrete: this.session.carrinhoTotalNotaFiscalSemFrete.replace(",", ".")
                }));
            },
            filterCompanieFob: function (val) {
                return val.code === this.cartInfo.fob.value.code;
            },
            updateCompanieFob: function (code) {
                this.isProcessing = true;
                var item = this.fobCompanies.filter(this.filterCompanieFob)[0]

                // console.log('item', item)

                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("alterando transportadora...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result (alterar transportadora): ",json);
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                    this.isProcessing = false;
                }
                xhr.open("POST", this.$apiUrl + "Carrinho.svc/AlterarTransportadora");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                    codigoTransportadora: item.code,
                    tipoFrete: 1,
                    tipoCorreio: -1,
                    valorFrete: 0,
                    tipoAereo: false
                }));
            },
            getFobCompanies: function () {
                this.cifCompanies = []
                var self = this;
                if (localStorage.meioPagamento === 'Boleto' && self.blockRetira == false) {
                    this.showCifCompanies = false;
                    let obj = { code: 29, label: "O MESMO" };
                    this.fobCompanies.push(obj);
                    this.cartInfo.fob.value = obj;
                    this.updateCompanieFob(29);
                    var $resp = jQuery("#responsible");
                    $resp.show()
                    return;
                }

                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("Carregando transportadoras fob...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result (fob): ",json);

                            // COVID-19
                            if (self.blockRetira == false) {
                                this.fobCompanies.push({ code: 29, label: "O MESMO" });
                            }
                            json.forEach((element) => {
                                let item = {};
                                item.code = element.TraCodigo
                                item.label = element.SaidaParaTela;
                                this.fobCompanies.push(item);

                            })

                            let fobSelecionada = this.fobCompanies.filter(c => c.code == this.codigoTransportadora);
                            if (fobSelecionada.length > 0)
                                this.cartInfo.fob.value = fobSelecionada[0];
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Transportadora.svc/loadfob");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    emp_filial: 1,
                    uf: this.formulario.Uf_cliente,
                    cidade: this.formulario.Cidade_cliente
                }));
            },
            getResponsible: function () {
                // return [
                //     { code: 1, label: "JOÃO SILVA"},
                //     { code: 2, label: "MARIO BROS"},
                //     { code: 3, label: "JOSÉ SANTOS"}
                // ];

                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log("Carregando responsaveis...");
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            // console.log("Result (resp retira): ",json);
                            json.forEach((element, index) => {
                                let item = {};
                                item.code = element.RgRespRetira;
                                item.label = element.NomeRespRetira;
                                this.responsibles.push(item);
                            });

                            let responsavel = this.responsibles.filter(c => c.code == this.rgResponsavel);
                            if (responsavel.length > 0) {
                                this.cartInfo.responsible.value = responsavel[0];
                            }
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Transportadora.svc/loadclientesretira");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send();
            },
            updateResponsible: function (item) {
                let xhr = new XMLHttpRequest()

                xhr.open("POST", this.$apiUrl + "Carrinho.svc/AlterarResponsavelRetira")
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        // console.log('alterarResponsavel', JSON.parse(xhr.responseText))
                    }
                }

                xhr.send(JSON.stringify({
                    codigoPedido: this.codigoKombiInt,
                    nomeResponsavel: item.label,
                    rgResponsavel: item.code
                }))
            }
        }
    }
</script>
